import React from 'react'
import { SellableType, SellableCardFragment } from '#src/generated/graphql'
import useBreakpoint from '#src/hooks/useBreakpoint'
import FireIcon from './fire.svg'
import styles from './styles.css'

interface SellableCardLabelProps {
  sellable: SellableCardFragment
}

const SellableCardLabel: React.SFC<SellableCardLabelProps> = ({ sellable }) => {
  const metrics = (sellable.parent && sellable.parent.metrics) || sellable.metrics
  const isMobile = !useBreakpoint('sm')

  if (sellable.areAllVariantsOutOfStock) {
    return <div className={styles.outOfStock}>Out of stock</div>
  } else if (metrics) {
    const viewsLast7 = metrics.totalUniquePVsInPastWeek || 0
    const purchasesLast30 = metrics.totalPurchasesInLast30Days || 0

    if (purchasesLast30 > 0) {
      // "5 puchased this month" or "Best Seller"
      return (
        <div className={styles.label}>
          <FireIcon />
          {isMobile || purchasesLast30 <= 2
            ? `Best Seller`
            : `${purchasesLast30} ${
                sellable.type === SellableType.SERVICE ? 'booked' : 'bought'
              } this month`}
        </div>
      )
    } else if (viewsLast7 >= 5) {
      // "8 viewing"
      return (
        <div className={styles.label}>
          <FireIcon />
          {viewsLast7} viewing
        </div>
      )
    }
  }
  return null
}

export default SellableCardLabel
